<template>
	<el-dialog :title="title" width="400px" :visible.sync="visible" :before-close="beforeClose">
		<div class="yx-color-text-p-1 fz-14" v-if="isCanDel">
			{{ desc1 }}
		</div>
		<div class="yx-color-text-p-1 fz-14" v-else>
			<template v-if="isDr">
				<p
					>该{{ drRoleType.name }}下有 <span class="yx-color-primary">{{ followObj.anchorTotal }}</span> 个达人和
					<span class="yx-color-primary">{{ followObj.institutionTotal }}</span> 个团长正在跟进；</p
				>
				<p class="mt-6">为避免达人和团长无人跟进，请将达人和团长分配给其他</p>
				<p class="mt-6">{{ drRoleType.name }}后再删除子账号</p>
				<div class="mt-12">
					<el-button type="text" @click="openUrl('https://chaoyongtuan.yuque.com/dtmxux/ggvo88/qewfsx')">如何重新分配达人跟进人？</el-button>
					<br />
					<el-button type="text" @click="openUrl('https://yangxuan.feishu.cn/docx/PgzmdS3d2o0SzjxwaBVcWYrKnhU')">如何重新分配团长跟进人？</el-button>
				</div>
			</template>
			<template v-else-if="isZs">
				<p
					>该{{ zsRoleType.name }}下有 <span class="yx-color-primary">{{ followObj.productTotal }}</span> 个商品正在跟进</p
				>
				<p class="mt-6">为避免相应商品的样品订单无人处理</p>
				<p class="mt-6">请将商品重新分配给其他{{ zsRoleType.name }}后再删除子账号。</p>
				<div>
					<el-button type="text" @click="openUrl('https://chaoyongtuan.yuque.com/dtmxux/ggvo88/aiahlo')">如何重新分配商品？</el-button>
				</div>
			</template>
			<template v-else-if="isAll">
				<p
					>该{{ zsRoleType.name }}下有 <span class="yx-color-primary">{{ followObj.productTotal }}</span> 个商品正在跟进</p
				>
				<div>
					<el-button type="text" @click="openUrl('https://chaoyongtuan.yuque.com/dtmxux/ggvo88/aiahlo')">如何重新分配商品？</el-button>
				</div>
				<p
					>该{{ drRoleType.name }}下有 <span class="yx-color-primary">{{ followObj.anchorTotal }}</span> 个达人和
					<span class="yx-color-primary">{{ followObj.institutionTotal }}</span> 个团长正在跟进；</p
				>
				<div class="mt-12">
					<el-button type="text" @click="openUrl('https://chaoyongtuan.yuque.com/dtmxux/ggvo88/qewfsx')">如何重新分配达人跟进人？</el-button>
					<br />
					<el-button type="text" @click="openUrl('https://yangxuan.feishu.cn/docx/PgzmdS3d2o0SzjxwaBVcWYrKnhU')">如何重新分配团长跟进人？</el-button>
				</div>
				<p class="mt-6">为避免相应合作无人跟进造成损失，请将商品、达人、团长分配给其他子账号跟进后重试</p>
			</template>
			<template v-else>
				<p>删除改角色</p>
			</template>
		</div>

		<div slot="footer" class="dialog-footer">
			<template v-if="isCanDel">
				<el-button @click="visible = false"> 取消 </el-button>
				<el-button type="primary" @click="confirmDel">确认删除</el-button>
			</template>
			<template v-else>
				<el-button type="primary" @click="visible = false">知道了</el-button>
			</template>
		</div>
	</el-dialog>
</template>
<script>
import { zsRoleType, drRoleType, tzRoleType } from '@/utils/dataMap';
import { accountDelete } from '@/api/teamManage';
export default {
	computed: {
		roleType({ userType }) {
			const [a] = userType;
			return userType.length === 1 ? a : 'all';
		},
		title({ roleType }) {
			if (this.isUserType) {
				return '删除用户类型';
			}
			const obj = {
				[tzRoleType.id]: `删除子账号`,
				[zsRoleType.id]: `删除${zsRoleType.name}子账号`,
				[drRoleType.id]: `删除${drRoleType.name}子账号`,
				all: `删除子账号`,
			};
			return obj[roleType];
		},
		desc1({ roleType }) {
			if (this.userType.length == 0) {
				// 兼容没有用户类型的情况
				return `删除子账号`;
			}
			const obj = {
				[tzRoleType.id]: `删除子账号`,
				[zsRoleType.id]: `删除${zsRoleType.name}子账号后，该${zsRoleType.name}的订单业绩归属与业绩统计不会变更`,
				[drRoleType.id]: `删除${drRoleType.name}子账号后，该${drRoleType.name}的订单业绩归属与业绩统计不会变更`,
				all: `删除${zsRoleType.name}子账号后，该${zsRoleType.name}的订单业绩归属与业绩统计不会变更 \n 删除${drRoleType.name}子账号后，该${drRoleType.name}的订单业绩归属与业绩统计不会变更`,
			};
			return obj[roleType];
		},
		isDr({ roleType }) {
			return roleType === drRoleType.id;
		},
		isZs({ roleType }) {
			return roleType === zsRoleType.id;
		},
		isAll({ roleType }) {
			return roleType === 'all';
		},
	},
	data() {
		return {
			visible: false,
			isCanDel: true,
			zsRoleType,
			drRoleType,
			followObj: {},
			userType: [],
		};
	},
	methods: {
		show(userType, isCanDel, params, followObj, isUserType = false) {
			this.userType = userType;
			this.followObj = followObj;
			this.params = params;
			this.isCanDel = isCanDel;
			this.visible = true;
			this.isUserType = isUserType;
		},
		async confirmDel() {
			await accountDelete(this.params);
			this.$emit('refresh');
			this.$message.success('删除成功！');
			this.visible = false;
		},
		beforeClose() {
			this.userType = [];
			this.followObj = {};
			this.visible = false;
		},
		openUrl(url) {
			window.open(url, '_blank');
		},
	},
};
</script>
